<template>
  <div class="c-group g-container">
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 设置推广计划 </BreadcrumbItem>
    </Breadcrumb>

    <moduler v-for="item in subModules" :media="media" :name="item.href" :key="item.id" :title="item.name">
      <!-- 基础信息 -->
      <template v-if="item.href === 'group_creat'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广计划名称</span>
          </Col>
          <Col span="12">
            <input-len v-model="campaign.campaignFeedName" placeholder="最大90个字符，1个中文等于2个字符" :max="90" width="352"></input-len>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广对象</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.subject" type="button" @on-change="changeSubject">
              <Radio :label="1" :disabled="editState">网站链接</Radio>
              <Radio :label="2" :disabled="editState">应用下载(iOS)</Radio>
              <Radio :label="3" :disabled="true">应用下载(Andriod)</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <!-- 游戏信息 -->
        <Row class="row-item" :gutter="12" v-if="campaign.subject === 2 && !editState">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">选择游戏</span>
          </Col>
          <Col span="12">
            <auto-complete
              v-model="campaign.gameId"
              :data="platformGameData"
              placeholder="请选择IOS游戏"
              :disabled="editState"
              width="352"
              @on-select="handleGame"
            ></auto-complete>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="campaign.subject === 2">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">应用名称</span>
          </Col>
          <Col span="12">
            <input-len
              v-model="appinfo.appName"
              placeholder="最大20个字符，1个中文等于2个字符"
              :max="20"
              width="352"
              :disabled="editState"
            ></input-len>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="campaign.subject === 2">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广的URL</span>
          </Col>
          <Col span="12">
            <Input v-model="appinfo.appUrl" placeholder="请输入推广应用链接" style="width: 352px" disabled></Input>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广计划预算</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="budgetType" type="button" @on-change="changeBudget">
              <Radio label="NONE">不限</Radio>
              <Radio label="DAY">指定预算</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="budgetType === 'DAY'">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">日预算</span>
          </Col>
          <Col span="12">
            <Input
              v-model="campaign.budget"
              placeholder="请输入50-9999999.99数值，最多2位小数"
              style="width: 352px"
              @on-blur="inputTrim('budget', campaign.budget, campaign, true)"
            >
              <span slot="append" style="padding: 0 6px"> 元 </span>
            </Input>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广日期</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="timeType" type="button" @on-change="changeTime">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM">指定日期</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="timeType === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="12">
            <Row :gutter="12">
              <Col span="24">
                <DatePicker
                  type="date"
                  :value="campaign.starttime"
                  placeholder="请选择开始日期"
                  style="width: 160px"
                  :options="{ disabledDate: startOption }"
                  @on-change="changeStartTime"
                ></DatePicker>
                <span class="m-date-split">~</span>
                <DatePicker
                  type="date"
                  :value="campaign.endtime"
                  placeholder="请选择结束日期"
                  style="width: 160px"
                  :options="{ disabledDate: endOption }"
                  @on-change="changeEndTime"
                ></DatePicker>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广时段</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="timeRange" type="button" @on-change="radioChange('weektimeData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="RANGE">指定时段</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="timeRange === 'RANGE'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">&nbsp;</Col>
          <Col span="18">
            <drag-weektime v-model="mult_timeRange" :data="weektimeData" :colspan="1" @on-clear="clearWeektime"></drag-weektime>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放速度</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="campaign.bgtctltype" type="button">
              <Radio :label="1">标准</Radio>
              <Radio :label="0">平衡投放</Radio>
              <Radio :label="2">展现优先</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">批量建立</span>
          </Col>
          <Col span="12">
            <i-switch v-model="batch" :disabled="editState" @on-change="changeBatch" />
          </Col>
        </Row>
        <Row v-if="batch" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="始末数字最多相差10">
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field">数量</span>
          </Col>
          <Col span="12">
            <Input
              v-model="campaign.start_num"
              placeholder="起始数"
              style="width: 60px"
              @on-blur="inputTrim('start_num', campaign.start_num, campaign)"
            />
            <span>&nbsp; ~ &nbsp;</span>
            <Input
              v-model="campaign.end_num"
              placeholder="结束数"
              style="width: 60px"
              @on-blur="inputTrim('end_num', campaign.end_num, campaign)"
            />
          </Col>
        </Row>
      </template>
    </moduler>

    <!-- 批量结果 -->
    <resulter
      v-model="model"
      :show="loading"
      title="建立推广计划结果反馈"
      head="推广计划创建结果"
      :columns="columns"
      :data="data"
      @on-retry="retry"
      @on-next="jump"
    ></resulter>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" v-if="editState" :loading="saving" @click.stop="submit(0)">
            <span v-if="!saving">保存并关闭</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(1)" :disabled="true">
            <span v-if="!loading">保存并新建计划</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submitToNext" :disabled="true">
            <span v-if="!loading">保存并下一步</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { getSession } from '@/common/js/api'
import { formatDate, getTime, splicing, isArray, isNumber } from '@/common/js/utils'
import { getCaoHuaGames } from '@/api/common.model'
import { creatCampaign, getCampaign, uploadCampaign } from '@/api/baidu.model'
import weektimeData from '@/data/baidu/weektime_data'
// 引用组件
import DragWeektime from '@/components/drag/drag-weektime.vue'
import resulter from './components/convert/resulter.vue'
// 日期今天
const now = formatDate(new Date(), 'yyyy-MM-dd')
const unsplicing = (list) => {
  let same
  let i = -1
  const len = list.length
  const arr = []

  if (!len) return
  while (++i < len) {
    const item = list[i]
    if (!item.check) {
      if (item.check === Boolean(same)) {
        arr.push(...['、', item.begin, '~', item.end])
      } else if (arr.length) {
        arr.pop()
        arr.push(item.end)
      }
    }
    same = Boolean(!item.check)
  }
  arr.shift()
  return arr.join('')
}

export default {
  name: 'group',
  mixins: [mixin],
  components: { DragWeektime, resulter },
  computed: {
    editState() {
      return this.$router.currentRoute.query.t === 'edit'
    },
    startOption() {
      return (date) => {
        return date && date.valueOf() < Date.now() - 86400000
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.campaign.starttime)
      }
    },
    platformGameData() {
      let gameData
      if (this.campaign.subject === 1) {
        gameData = this.gameData
      } else if (this.campaign.subject === 2) {
        gameData = this.gameData.filter((ret) => ret.ch_platform_id === 2)
      } else if (this.campaign.subject === 3) {
        gameData = this.gameData.filter((ret) => ret.ch_platform_id === 1)
      }
      return gameData
    },
    mult_timeRange() {
      const arr = []
      this.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    }
  },
  watch: {
    // 投放时间段
    weektimeData: {
      handler(nVal) {
        this.schedule = this.getWeektime(nVal)
      },
      deep: true
    },
    // 预算获取
    'campaign.budget'(nVal) {
      if (nVal > 0) {
        this.budgetType = 'DAY'
      }
    }
  },
  methods: {
    getData() {
      getCampaign({
        ad_account_id: this.campaign.ad_account_id,
        id: this.campaign.campaignFeedId
      }).then((data) => {
        if (data && data.length) {
          data = data.pop()
          const { starttime, endtime, appinfo, schedule } = data
          if (appinfo && appinfo.appName) this.appinfo = appinfo
          if (!endtime) data.starttime = null
          else {
            this.timeType = 'CUSTOM'
            data.starttime = formatDate(new Date(starttime), 'yyyy-MM-dd')
            data.endtime = formatDate(new Date(endtime), 'yyyy-MM-dd')
          }
          // schedule
          if (schedule.length) {
            this.reverWeektime(schedule)
            this.timeRange = 'RANGE'
          }
          this.campaign = Object.assign({}, this.campaign, data)
        }
        // 加载完成
        if (this.$router.currentRoute.query.t !== 'edit') this.campaign.campaignFeedId = undefined
        this.$Spin.hide()
      })
    },
    reverWeektime(schedule) {
      for (let i = this.weektimeData.length - 1; i >= 0; i--) {
        const children = this.weektimeData[i].child
        const hours = []
        const weekDay = schedule.filter((ret) => ret.weekDay === i + 1)
        for (const day of weekDay) {
          const { startHour, endHour } = day
          if (isNumber(startHour) && isNumber(endHour)) {
            for (let i = startHour; i < endHour; i++) {
              hours.push(i)
            }
          }
        }
        for (let j = children.length - 1; j >= 0; j--) {
          const n = hours.includes(j)
          this.$set(this.weektimeData[i].child[j], 'check', Boolean(!n))
        }
      }
    },
    // 选择游戏
    handleGame(meta) {
      this.campaign.gameId = meta.id
      this.appinfo.appName = meta.name
      this.appinfo.appUrl = meta.game_address
    },
    changeSubject(val) {
      if (val === 2) {
        this.appinfo = {
          appName: '',
          appUrl: ''
        }
      } else {
        this.appinfo = {}
      }
    },
    // 选择推广日期
    changeTime(val) {
      if (val === 'CUSTOM') {
        this.campaign.starttime = now
        this.campaign.endtime = now
      } else if (val === 'NONE') {
        this.campaign.starttime = null
        this.campaign.endtime = null
      }
    },
    changeStartTime(val) {
      const start = getTime(val)
      const end = getTime(this.campaign.endtime)
      if (end < start) this.campaign.endtime = val
      this.campaign.starttime = val
    },
    changeEndTime(val) {
      this.campaign.endtime = val
    },
    changeBudget(val) {
      if (val === 'NONE') this.campaign.budget = 0
      else this.campaign.budget = ''
    },
    changeBatch(val) {
      if (val) {
        this.campaign.start_num = ''
        this.campaign.end_num = ''
      } else {
        this.campaign.start_num = undefined
        this.campaign.end_num = undefined
      }
    },
    // 处理7*24位值
    getWeektime(val) {
      const data = []
      for (const item of val) {
        const keys = unsplicing(item.child)
        if (keys) {
          if (keys.indexOf('、') > 0) {
            const some = keys.split('、')
            some.map((ret) => {
              const h = ret.indexOf('~') > 0 && ret.split('~')
              data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
            })
          } else if (keys.indexOf('~') > 0) {
            const h = keys.split('~')
            data.push({ weekDay: item.row + 1, startHour: h && parseInt(h[0]), endHour: h && parseInt(h[1]) })
          }
        }
      }
      return data
    },
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    preloadData() {
      // 请求开始
      this.$Spin.show()
      getCaoHuaGames().then((data) => {
        isArray(data) && (this.gameData = data)
        if (this.campaign.campaignFeedId) this.getData()
        else this.$Spin.hide()
      })
    },
    customValid() {
      const err = []
      // 时间段必选
      if (this.timeRange === 'RANGE' && !this.schedule.length) {
        err.push({ feild: '推广时段', msg: '推广时段必须设置周一至周日中的一小时' })
      }
      // 游戏必选
      if (this.campaign.subject === 2 && !this.editState && !this.campaign.gameId) {
        err.push({ feild: '选择游戏', msg: '选择游戏不能为空' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'campaign/campaignFeedName',
          relyon: 'editState',
          relyvalue: false,
          require: true,
          min: 2,
          max: 90,
          desc: '推广计划名称'
        },
        {
          name: 'appinfo/appName',
          require: true,
          relyon: 'campaign/subject',
          relyvalue: 2,
          min: 1,
          max: 20,
          desc: '应用名称'
        },
        {
          name: 'appinfo/appUrl',
          require: true,
          pattern: '^((https|http)?://)[^\\s]+',
          relyon: 'campaign/subject',
          relyvalue: 2,
          min: 1,
          max: 1024,
          desc: '推广的URL'
        },
        {
          name: 'campaign/starttime',
          require: true,
          pattern: '^(\\d{4})(-|/)(\\d{2})(-|/)(\\d{2})$',
          relyon: 'timeType',
          relyvalue: 'CUSTOM',
          min: 1,
          max: 10,
          desc: '推广起始日期'
        },
        {
          name: 'campaign/endtime',
          require: true,
          pattern: '^(\\d{4})(-|/)(\\d{2})(-|/)(\\d{2})$',
          relyon: 'timeType',
          relyvalue: 'CUSTOM',
          min: 1,
          max: 10,
          desc: '推广结束日期'
        },
        {
          name: 'campaign/budget',
          require: true,
          relyon: 'budgetType',
          relyvalue: 'DAY',
          min: 50,
          max: 9999999.99,
          desc: '日预算',
          msg: '请输入50-9999999.99数值，最多2位小数'
        },
        {
          name: 'campaign/start_num',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量起始数'
        },
        {
          name: 'campaign/end_num',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量结尾数'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(next) {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const loading = next ? 'loading' : 'saving'
      const params = Object.assign({}, this.campaign, { schedule: this.schedule }, this.appinfo)
      this[loading] = true
      uploadCampaign(params).then((data) => {
        this[loading] = false
        // 创推广单元
        if (next && data) {
          this.data = [data]
          this.jump()
        } else if (data) {
          this.closePageForm()
        }
      })
    },
    submitToNext() {
      this.errRes = [...this.valid(), ...this.customValid(), ...this.betchValid(this.campaign)] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const params = Object.assign({}, this.campaign, { schedule: this.schedule }, this.appinfo)
      this.loading = true
      creatCampaign(params).then((data) => {
        this.loading = false
        if (data && data.info) {
          this.data = data.info || []
          if (this.data.length > 1) this.model = true
          else if (this.data.length) this.jump()
        }
      })
    },
    jump() {
      if (isArray(this.data) && this.data.length) {
        const ids = this.data.filter((ret) => ret.id || ret.campaignFeedId).map((ret) => ret.id || ret.campaignFeedId)
        if (ids.length) {
          window.sessionStorage.setItem('campaigns', JSON.stringify(ids))
          this.$store.commit('Baidu/setCurrent', 'plan')
          this.$store.commit('Baidu/changeState', 'group')
          this.$router.push({
            name: 'baiduplan',
            params: { id: ids[0] }
          })
        } else {
          this.$Message.error({
            closable: true,
            duration: 5,
            content: '创建推广计划全部失败，不能创建推广单元'
          })
        }
      }
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      gameData: [], // 游戏数组
      budgetType: 'NONE', // 默认不限预算
      timeType: 'NONE', // 推广日期
      timeRange: 'NONE', // 推广时段
      weektimeData: weektimeData, // 时间区域
      appinfo: {}, // 推广app信息
      batch: null, // 批量
      campaign: {
        ad_account_id: this.$store.state.Baidu.account, // 当前账号
        campaignFeedId: this.$router.currentRoute.query.id,
        campaignFeedName: '',
        gameId: '', // 游戏ID
        subject: 1, // 推广对象
        bgtctltype: 1, // 投放速度
        budget: 0, // 预算
        starttime: null,
        endtime: null
      },

      model: null, // 批量结果对话框显示状态
      columns: [
        {
          key: 'media_name',
          title: '媒体'
        },
        {
          key: 'name',
          title: '推广计划'
        },
        {
          key: 'msg',
          title: '推广计划建立结果'
        }
      ], // 结果表格
      data: [] // 批量结果
    }
  },
  created() {
    if (this.$router.currentRoute.query.t !== 'edit') this.beforeHandler()
    this.$store.commit('Baidu/clearModulerLinks')
    this.campaign.ad_account_id = getSession('qianduan_media_account_id')
    this.preloadData()
  },
  mounted() {
    this.toTop()
  }
}
</script>
<style lang="scss" scoped>
.m-date-split {
  line-height: 32px;
  font-size: 16px;
  display: inline-block;
  padding: 0 8px;
}

.c-group-submit {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;

  .c-btns-submit {
    text-align: right;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
